import axios from "../../axios";

export const duplicateTxn = async ( accountId,) => { 
    try {
      const url = `/api/v3/analysis/duplicateTxns?accountId=${accountId}&page=1&size=100` ;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
}

export const circularTxn = async ( 
    accountId,
    aggregated = false,
  ) => { 
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/circularTransactions?reportReferenceId=${accountId}`  : `/api/v3/analysis/circularTransactions?accountId=${accountId}` ;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
}

export const intraBankTxn = async ( 
    accountId,
    aggregated = false,
  ) => { 
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/intraBankFundTransfer?reportReferenceId=${accountId}`  : `/api/v3/analysis/intraBankFundTransfer?accountId=${accountId}` ;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
}
export const odccUtilizationTxn = async ( 
    accountId,
    aggregated = false
  ) => { 
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/utilization?reportReferenceId=${accountId}`  : `/api/v3/analysis/utilization?accountId=${accountId}` ;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
}
export const recurringDeposite = async ( 
    accountId,
    aggregated = false,
    type= "recurringDeposits"
  ) => { 
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/patterns?reportReferenceId=${accountId}&type=${type}`  : `/api/v3/analysis/patterns?accountId=${accountId}&type=${type}` ;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
}